export default __webpack_public_path__ + "static/media/shunzhanlogo.df384f10.png";